<template>
  <div v-show='data.hidden === false' class="col-sm-6 h-col-inputBoxSub">
    <div class='h-subscriber-inputLit' v-if="data.showName !== ''">
      <span v-show="getRequired" class="h-red-code">* </span>
      {{data.showName}}
    </div>
    <div>
      <input :ref='data.name' :class="['e-control', 'e-textbox', 'e-lib', 'e-input',{ 'readonly-background': data.readonly}]" type="password" autoComplete="new-password" maxLength='64' :placeholder='data.placeholder' :disabled='data.disabled' :readonly='data.readonly' :name='data.name' v-model='params.paramVal' @click='clickFunc' @blur='blurFunc' @keyup='keyUpFunc'/>
    </div>
  </div>
</template>
<script>
import common from '../common';

export default {
  name: 'Son_Password',
  props: [
    'data',
    'opCode'
  ],
  mixins: [common],
  data() {
    return {
      params: {
        name: this.data.name,
        paramVal: this.data.value
      },
      text: [
        'h-subscriber-inputBoxDiv',
        'h-subscriber-inputBoxDivInPartten1',
        'h-subscriber-inputBoxDivInPartten2'
      ],
    };
  },
  methods: {
    hhe() {
      console.log('???/')
    }
  },
  created() {
    this.$parseInitData();
  }
};
</script>

<style scoped>

</style>
